import { render, staticRenderFns } from "./dagitim.vue?vue&type=template&id=5e184c7e&"
import script from "./dagitim.vue?vue&type=script&lang=js&"
export * from "./dagitim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports